<template>
    <div class="house-management parent-frame">
        <div class="house-management-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'houseManagement',
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .house-management{
        position: relative;
        .house-management-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px){
        .house-management{
            .house-management-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/HouseManagement.vue